import React from "react";
import { Link } from "react-router-dom";
import "./Galleria.css";

import caramanu from "../assets/studi/1caramanu.jpg";
import nelleforme from "../assets/slidemenu/studi.jpg";
import salvatore from "../assets/studi/3salvatore.jpg";
import studiodisal from "../assets/studi/4studiodisal.jpg";

const opere = [
  { img: caramanu, titolo: "CARA MANU", righe: ["tecnica mista e collage su tela", "30 x 40 cm", "2022"] },
  { img: nelleforme, titolo: "NELLE FORME DI UN ALTRO DOLORE", righe: ["tecnica mista, gesso e foglia oro su tela", "90 cm", "2022"] },
  { img: salvatore, titolo: "SALVATORE", righe: ["olio, tela grezza e gesso su tela", "100 x 100 cm", "2019"] },
  { img: studiodisal, titolo: "STUDIO DI SALVATORE", righe: ["olio su tela", "40 x 50 cm", "2020"] },
];

const Studi = () => {
  return (
    <div className="galleria">
      {opere.map((o, i) => (
        <figure className="opera" key={i}>
          <img src={o.img} alt={o.titolo} draggable="false" />
          <figcaption className="didascalia">
            <strong>{o.titolo}</strong>
            {o.righe.map((r, j) => (
              <span key={j}>{r}</span>
            ))}
          </figcaption>
        </figure>
      ))}

      <Link to="/Home" className="torna">
        Torna alla home
      </Link>
    </div>
  );
};

export default Studi;
